// Serializer for rendering a blog post's custom blocks
import React from 'react'
import Code from '../components/blog/Code'
import ImageBlock from '../components/blog/ImageBlock'
// import Tex from '@matejmazur/react-katex'

export default {
  types: {
    code: ({ node }) => <Code node={node} />,
    imgBlock: ({ node }) => {
      return <ImageBlock node={node} />
    },
    // latex: ({ node }) => {
    //   return <Tex math={node.body} block />
    // },
  },
}
